import pushOptimizelyEvent from 'pathfinder/utils/pushOptimizelyEvent';
export var OPTIMIZELY_QUIZ;
(function (OPTIMIZELY_QUIZ) {
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_OVERLAY_STYLES"] = "quiz_module_mobile_overlay_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_OVERLAY_LABEL"] = "quiz_module_mobile_overlay_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_QUIZ_TITLE_STYLES"] = "quiz_module_mobile_quiz_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_QUIZ_TITLE_LABEL"] = "quiz_module_mobile_quiz_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_TAKE_THE_QUIZ_BUTTON_STYLES"] = "quiz_module_mobile_take_the_quiz_button_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_TAKE_THE_QUIZ_BUTTON_LABEL"] = "quiz_module_mobile_take_the_quiz_button_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_MOBILE_TAKE_THE_QUIZ_LABEL"] = "quiz_module_mobile_take_the_quiz_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_PLACEMENT_STYLES"] = "quiz_module_desktop_placement_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_HEADER_STYLES"] = "quiz_module_destkop_header_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_HEADER_LABEL"] = "quiz_module_desktop_header_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_IMAGE_STYLES"] = "quiz_module_desktop_image_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_LINK_STYLES"] = "quiz_module_desktop_link_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_LINK_LABEL"] = "quiz_module_desktop_link_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_TITLE_CONTAINER_STYLES"] = "quiz_module_desktop_title_container_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_QUIZ_TITLE_STYLES"] = "quiz_module_desktop_quiz_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_QUIZ_TITLE_LABEL"] = "quiz_module_desktop_quiz_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_DESKTOP_QUIZ_QUESTIONS_STYLES"] = "quiz_module_desktop_quiz_questions_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_BUG_STYLES"] = "quiz_module_bug_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODULE_BUG_LABEL"] = "quiz_module_bug_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_TIMED_QUIZ_TITLE_STYLES"] = "quiz_modal_timed_quiz_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_TIMED_QUIZ_TITLE_LABEL"] = "quiz_modal_timed_quiz_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_TITLE_STYLES"] = "quiz_modal_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_TITLE_LABEL"] = "quiz_modal_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_QUESTIONS_STYLES"] = "quiz_modal_questions_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_START_QUIZ_BUTTON_STYLES"] = "quiz_modal_start_quiz_button_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_START_QUIZ_BUTTON_LABEL"] = "quiz_modal_start_quiz_button_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_BACKGROUND_CONTAINER_STYLES"] = "quiz_modal_background_container_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_BACKGROUND_CONTENT_STYLES"] = "quiz_modal_background_content_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RESULT_SCREEN_TITLE_STYLES"] = "quiz_modal_result_screen_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RESULT_SCREEN_TITLE_LABEL"] = "quiz_modal_result screen_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SCORE_TITLE_STYLES"] = "quiz_modal_score_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SCORE_TITLE_LABEL"] = "quiz_modal_score_title_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SCORE_STYLES"] = "quiz_modal_score_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RETAKE_BUTTON_STYLES"] = "quiz_modal_retake_button_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RETAKE_BUTTON_LABEL"] = "quiz_modal_retake_button_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SEE_ANSWERS_LINK_STYLES"] = "quiz_modal_see_answers_link_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SEE_ANSWERS_LINK_LABEL"] = "quiz_modal_see_answers_link_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RESULTS_CONTAINER_STYLES"] = "quiz_modal_results_container_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RESULTS_SCORE_TITLE_STYLES"] = "quiz_modal_results_score_title_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_RESULTS_QUESTION_NUMBER_STYLES"] = "quiz_modal_results_question_number_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_ANSWER_LABEL_STYLES"] = "quiz_modal_answer_label_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_ANSWER_STYLES"] = "quiz_modal_answer_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SHARE_STYLES"] = "quiz_modal_share_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SHARE_LABEL"] = "quiz_modal_share_label";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SOCIAL_STYLES"] = "quiz_modal_social_styles";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SCORECARD_DIVIDER_TOP"] = "quiz_modal_scorecard_divider_top";
    OPTIMIZELY_QUIZ["QUIZ_MODAL_SCORECARD_DIVIDER_BOTTOM"] = "quiz_modal_scorecard_divider_bottom";
})(OPTIMIZELY_QUIZ || (OPTIMIZELY_QUIZ = {}));
export var optimizelyQuizPromptImpression = function (module) {
    return pushOptimizelyEvent('pathfinder_quiz_prompt_impression', module);
};
export var optimizelyQuizModalImpression = function (module) {
    return pushOptimizelyEvent('pathfinder_quiz_modal_impression', module);
};
export var optimizelyQuizPromptTakeQuizClick = function (module) {
    return pushOptimizelyEvent('pathfinder_quiz_prompt_take_quiz_click', module);
};
export var optimizelyQuizPromptGoToTriviaQuizClick = function (module) {
    return pushOptimizelyEvent('pathfinder_quiz_prompt_go_to_trivia_click', module);
};
export var optimizelyQuizModalCloseClick = function (module) {
    return pushOptimizelyEvent('pathfinder_quiz_modal_close_click', module);
};
